import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorFormatHelperService {
  componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

  rgbLongToHex(rgbLong: number): string {
    const b = Math.floor(rgbLong / 65536);
    const g = Math.floor((rgbLong - b * 65536) / 256);
    const r = Math.floor(rgbLong - b * 65536 - g * 256);
    return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  hexToRgbLong(hex: string | undefined): number | undefined {
    if (!hex) {
      return undefined;
    }

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let r, g, b;
    if (result) {
      r = parseInt(result[1], 16);
      g = parseInt(result[2], 16);
      b = parseInt(result[3], 16);
    } else {
      r = 0;
      g = 0;
      b = 0;
    }

    return b * 65536 + g * 256 + r;
  }
}
